/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconTrident = createReactComponent("outline", "trident", "IconTrident", [["path", { "d": "M3 6l2 -2v3a7 7 0 0 0 14 0v-3l2 2", "key": "svg-0" }], ["path", { "d": "M12 21v-18l-2 2m4 0l-2 -2", "key": "svg-1" }]]);

export { IconTrident as default };
//# sourceMappingURL=IconTrident.mjs.map
